import { DateTime } from 'luxon';
import type { ProductType } from '../../../models/product-type.enum';
import type { IProduct } from '../../../models/product.model';
import type { TravellerCategory } from '../../../models/traveller-category.enum';
import type TimeValidityViewModel from './time-validity.view-model';
import TariffZoneViewModel from './tariff-zone.view-model';

export default class ProductViewModel {
  public productId!: number;
  public productName!: string;
  public productType!: ProductType;
  public travellerCategory!: TravellerCategory;
  public priceInSek?: number | undefined;
  public timeValidity!: TimeValidityViewModel;
  public tariffZones!: TariffZoneViewModel[];

  public static mapToBusinessModel(m: ProductViewModel): IProduct {
    return {
      productId: m.productId,
      productName: m.productName,
      productType: m.productType,
      travellerCategory: m.travellerCategory,
      priceInSek: m.priceInSek,
      timeValidity: {
        type: m.timeValidity.type,
        amount: m.timeValidity.amount,
        unit: m.timeValidity.unit,
        fromDate: m.timeValidity.fromDate ? DateTime.fromISO(m.timeValidity.fromDate) : undefined,
        toDate: m.timeValidity.toDate ? DateTime.fromISO(m.timeValidity.toDate) : undefined,
        fromDateTime: m.timeValidity.fromDateTime ? DateTime.fromISO(m.timeValidity.fromDateTime) : undefined,
        toDateTime: m.timeValidity.toDateTime ? DateTime.fromISO(m.timeValidity.toDateTime) : undefined,
      },
      tariffZones: m.tariffZones?.map((tz) => TariffZoneViewModel.mapToBusinessModel(tz)) ?? [],
    };
  }
}
